"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var merch_components_1 = require("@carvana/merch-components");
var react_1 = __importDefault(require("react"));
var abbreviateNumber_1 = __importDefault(require("../../utils/abbreviateNumber"));
var TileDataContext_1 = require("../TileDataContext");
var VehicleHighlightBadge = (0, merch_components_1.createComponent)('span', {
    className: 'rounded bg-grey-1 px-8 py-4 text-center font-bold '
});
function VehicleCard() {
    var _a;
    var _b = (0, TileDataContext_1.useTileDataContext)(), _c = _b.tileData, jellyBeanMobileUrl = _c.jellyBeanMobileUrl, make = _c.make, mileage = _c.mileage, model = _c.model, stockNumber = _c.stockNumber, trim = _c.trim, vehicleInventoryType = _c.vehicleInventoryType, year = _c.year, transportCost = _c.transportCost, price = _b.financeInfo.price, cvnaVexFastlyImageUrl = _b.assets.cvnaVexFastlyImageUrl;
    var isWip = vehicleInventoryType === TileDataContext_1.InventoryTypeId.WIP;
    var imageToUse = isWip && jellyBeanMobileUrl
        ? jellyBeanMobileUrl
        : "".concat(cvnaVexFastlyImageUrl, "/").concat(stockNumber, "/standardizedHero.jpg");
    var yearMakeModel = "".concat(year, " ").concat(make, " ").concat(model);
    var isZeroDue = ((_a = price === null || price === void 0 ? void 0 : price.downPaymentDetails) === null || _a === void 0 ? void 0 : _a.totalCashDue) === 0;
    var showFreeShipping = transportCost === 0;
    return (react_1.default.createElement("div", { className: "mb-24 flex items-center gap-16 text-sm text-blue-6" },
        react_1.default.createElement("section", { className: "h-72 w-72 min-w-[72px] overflow-hidden rounded-full" },
            react_1.default.createElement("img", { src: imageToUse, alt: yearMakeModel, className: "h-full w-full object-cover" })),
        react_1.default.createElement("section", { className: "flex flex-col gap-8" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "font-bold" }, yearMakeModel),
                react_1.default.createElement("span", null, trim),
                " \u2022 ",
                react_1.default.createElement("span", null,
                    (0, abbreviateNumber_1.default)(mileage),
                    " miles")),
            react_1.default.createElement("div", { className: "flex gap-8" },
                isZeroDue && (react_1.default.createElement(VehicleHighlightBadge, null, "$0 due at order")),
                showFreeShipping && (react_1.default.createElement(VehicleHighlightBadge, null, "Free Shipping"))))));
}
exports.default = VehicleCard;
//# sourceMappingURL=VehicleCard.js.map